import React from 'react';
import { GREY_B } from 'app/constants/Colors';
import Icon from 'app/components/svgs/Icon';

/* eslint-disable max-len */
const SvgX: React.FunctionComponent<
  React.ComponentProps<typeof Icon> & {
    color?: string,
  }
> = ({
  color = GREY_B,
  ...props
}) => (
  <Icon {...props} viewBox="0 0 30 30">
    <g transform="translate(-28 -28)" fill={color} fillRule="evenodd">
      <rect transform="scale(1 -1) rotate(45 146.5 0)" x={23.91} y={39.41} width={38} height={7} rx={3.5} />
      <rect transform="scale(1 -1) rotate(-45 -60.68 0)" x={23.91} y={39.41} width={38} height={7} rx={3.5} />
    </g>
  </Icon>
);
/* eslint-enable max-len */

export default SvgX;
